// All permissions for this module.
// Example of the constant:
// export const EXAMPLE_PERM = "Perm Id"

export const SEE_REPORTS_PAGE = 1005;
export const CONFIGURE_ADMIN_PANEL = 2;
export const SEE_GENERAL_SETTINGS = 3;
export const SEE_GENERAL_SETTINGS_USERS = 4;
export const SEE_GENERAL_SETTINGS_BRANCHES = 5;
export const SEE_GENERAL_SETTINGS_PERMISSIONS = 6;
